export default function account($) {

    $(document).on('click', '[data-action="rename_design"]', function () {
        const $button = $(this).hide();
        const $title = $button.siblings('[data-design-title]').hide();
        const current = $title.text();
        const $input = $('<input>', { type: 'text', class: 'wc__account-design-input', maxlength: 80, value: current }).insertBefore($title);

        const finish = (name) => {
            $input.remove();
            $title.text(name || $button.data('default')).show();
            $button.show();
        };

        $input
            .on('keydown', (event) => {
                if (event.key === 'Enter') $input.trigger('blur');
                if (event.key === 'Escape') $input.val(current).trigger('blur');
            })
            .one('blur', () => {
                const name = $input.val().trim();

                finish(name);

                if (name === current) return;

                $.post(ajaxURL, { action: 'rename_design', nonce: ajaxNonce, key: $button.data('key'), name: name })
                    .fail(() => finish(current));
            })
            .trigger('focus')
            .trigger('select');
    });

}
